// extracted by mini-css-extract-plugin
export default {"scrollable-content":"ViewCurrencyDetails_scrollable-content__ivRFi","card":"ViewCurrencyDetails_card__XSCom","ant-card-head-title":"ViewCurrencyDetails_ant-card-head-title__Yjm8l"};